import AOS from "aos";
import "aos/dist/aos.css";

jQuery(($) => {
	AOS.init({ disable: "mobile" });

	$(window).on("load", function () {
		AOS.refresh();
	});

	/****************** POPUP ******************/

	let popit = 0;
	let popClicked = 0;

	if ($(".more-link").length > 0) {
		$(".more-link").on("click", function () {
			$(".col-right").hide();
			$(".col-left").addClass("active");

			$(".col-more").toggleClass("active");
			$(".more-link").hide();
			$(".more-link-close").show();
		});

		$(".more-link-close").on("click", function () {
			$(".col-more").toggleClass("active");
			$(".more-link").show();
			$(".more-link-close").hide();

			$(".col-right").show();
			$(".col-left").removeClass("active");
		});
	}

	if ($(".popup").length > 0) {
		$(".popup-button, .close-popup-icon").on("click", function () {
			popit++;

			const classList = $(this).attr("class").split(" ");
			$(`#${classList[1]}`).toggleClass("show");
			$("body").addClass("is--popped");

			popClicked = 1;
		});

		$(document).on("click", function (e) {
			if (
				!$(e.target).closest(".popup-interior-copy").length &&
				popit >= 1 &&
				popClicked != 1
			) {
				if ($(".popup.show").is(":visible")) {
					$(".disclaimer").fadeOut();
					$(".popup.show").removeClass("show");
					$("body").removeClass("is--popped");
					console.log("clicked");
					popit = 0;
				}
			} else {
				popClicked = 0;
			}
		});
	}

	/****************** TOOLTIP HOVER ******************/

	let tool = 0;
	let justClicked = 0;

	if (window.innerWidth < 1024) {
		$(".info-icon").on("click", function () {
			tool++;
			$(".disclaimer").removeClass("active").fadeOut();
			$(this).siblings(".disclaimer").fadeIn("active");
			justClicked = 1;
		});

		if ($(".tooltip-container.disclaimer").length > 0) {
			$(document).on("click", function (e) {
				if (
					!$(e.target).next(".disclaimer").length &&
					tool >= 1 &&
					justClicked != 1
				) {
					if ($(".tooltip-container.disclaimer").is(":visible")) {
						$(".disclaimer").fadeOut();
						tool = 0;
					}
				} else {
					justClicked = 0;
				}
			});
		}
	}

	/**/

	/* $(".info-icon").on("hover", function () {
		$(".disclaimer").fadeOut();
		$(this).siblings(".disclaimer").fadeToggle();
	}); */
	if (window.innerWidth > 1023) {
		$(".info-icon")
			.on("mouseenter", handlerIn)
			.on("mouseleave", handlerOut);

		function handlerIn() {
			$(this).siblings(".disclaimer").fadeIn();
		}

		function handlerOut() {
			$(this).siblings(".disclaimer").fadeOut();
		}
	}

	/****************** BACKGROUND IMAGE EXPANDER ******************/

	/* if ($(".background-image").length > 0) {
        const animatedDiv = document.querySelector(".background-image");

        let initialPadding = 60;
        let padding = initialPadding;

        let scrollingAllowed = true;

        function updatePadding() {
            const scrollPosition = window.scrollY;

            const targetPadding = initialPadding - scrollPosition * 0.2; // Adjust the speed by changing the multiplier
            const easingFactor = 0.08; // Adjust this value for smoother or faster animation
            padding += (targetPadding - padding) * easingFactor;

            animatedDiv.style.padding = `0 ${Math.max(
                0,
                padding,
            )}px 0 ${Math.max(0, padding)}px`;

            if (padding <= 0) {
                scrollingAllowed = false;
            } else if (padding > 0) {
                scrollingAllowed = true;
            }

            requestAnimationFrame(updatePadding);
        }

        window.addEventListener("scroll", updatePadding);

        updatePadding();
    } */

	/****************** BUTTON STYLE ******************/

	/* $(".btn, .dealer a, button.gform_button")
		.on("mouseenter", function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find("span").css({ top: relY, left: relX });
		})
		.on("mouseout", function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find("span").css({ top: relY, left: relX });
		});
 */
	/****************** CHANGE DATEPICKER ICON ******************/

	if ($(".ui-datepicker-trigger").length > 0) {
		$(".ui-datepicker-trigger").attr(
			"src",
			"/wp-content/themes/pride/assets/dist/images/datepicker.svg"
		);
	}

	/****************** HAMBURGERS MENU ******************/

	$("#header").on("click", "button.navbar-toggler", function () {
		$(this).toggleClass("is-active");
		$("main#main").toggleClass("is--open");
		$("nav#header").toggleClass("menu-open");
		$("body").toggleClass("is--open");
	});

	$(".mobile-menu li a").on("click", function () {
		$("main#main").toggleClass("is--open");
		$("nav#header").toggleClass("menu-open");
		$("body").toggleClass("is--open");
		$("button.navbar-toggler").toggleClass("is-active");
	});

	/****************** HAMBURGERS MENU DROPDOWN ******************/

	$(".mobile-menu li.dropdown").on("click", function () {
		$(this).toggleClass("active");
	});

	/****************** ACCORDIONS ******************/

	$(".accord:has(div ul li.active)").addClass("active");

	$(".accord .header, .accord .answer").on("click", function () {
		var $parent = $(this).closest(".accord");

		if (!$parent.hasClass("active")) {
			$(".accord.active").removeClass("active");
			$parent.addClass("active");
		} else {
			$parent.removeClass("active");
		}
	});

	/****************** HIDE NAVBAR WHEN SCROLLING ******************/

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var $header = $("#header");
	var navbarHeight = $header.outerHeight();
	var st;

	$(window).on("resize scroll", function () {
		didScroll = true;
		st = $(window).scrollTop();

		/****************** STICKY SIDE ******************/

		/* if ($(".side-bar").length > 0) {
			if (st >= $(".spacer").offset().top + $(".spacer").outerHeight()) {
				$(".side-bar").addClass("sticky-side");
			} else {
				$(".side-bar").removeClass("sticky-side");
			}
		} */
	});

	setInterval(function () {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 0); //350

	function hasScrolled() {
		if (Math.abs(lastScrollTop - st) <= delta) return;

		if (st > lastScrollTop && st > navbarHeight) {
			$header.removeClass("expanded-header").addClass("nav-up");
		} else {
			if (st + $(window).height() < $(document).height()) {
				$header.removeClass("nav-up").addClass("expanded-header");
			}
		}

		lastScrollTop = st;
	}

	$(window).on("scroll", () => {
		if ($(window).scrollTop() === 0) {
			$("#header").removeClass("nav-up expanded-header");
		}
	});

	/****************** MOBILE DROPDOWN ******************/
	if (window.innerWidth < 1024) {
		if ($(".services-dropdown").length > 0) {
			$(".services-dropdown").on("click", function () {
				$(this).toggleClass("nav-is-visible");
			});

			$("#services-dropdown").on("change", function () {
				// Get the selected option's value
				console.log($(this).val());
				var selectedUrl = $(this).val();

				// Check if a valid URL is selected
				if (selectedUrl) {
					// Redirect to the selected URL
					window.location.href = selectedUrl;
				}
			});
		}
	}

	//let siteURL = window.location.origin;
	$("#menu-main-menu li a").each(function () {
		//console.log(this);
		if (window.location.href.indexOf("/services/") >= 0) {
			if (this.href.indexOf("/services/") >= 0) {
				$(this).parent().addClass("active");
				return false;
			}
		} else if (window.location.href.indexOf("/our-clients/") >= 0) {
			if (this.href.indexOf("/our-clients/") >= 0) {
				$(this).parent().addClass("active");
				return false;
			}
		} else if (window.location.href.indexOf("/blog/") >= 0) {
			/* if (this.href.indexOf("/blog/") >= 0) {
				console.log(window.location.href);
				console.log(this);
				$(this).siblings("li").addClass("active");
				$(this).children("li").addClass("active");
				return false;
			} */
		} else if (window.location.href.indexOf("/newsroom/") >= 0) {
			/* 	if (this.href.indexOf("/newsroom/") >= 0) {
				console.log(window.location.href);
				console.log(this);
				$(this).addClass("active");
				return false;
			} */
		}
	});

	/****************** Search ******************/

	var searchTimer;

	function performSearch() {
		$("#search-field").on("input", function () {
			let searchTerm = $("#search-field").val();
			console.log(searchTerm);
			if (searchTerm.length >= 2) {
				$.ajax({
					type: "POST",
					url: ajax_posts.ajaxurl,
					data: {
						action: "newsroom_search",
						search_term: searchTerm,
					},
					success: function (response) {
						$(".more-archive-container").hide();
						$("#archive--content").html(response);
					},
				});
			} else {
				// If search term is less than 3 characters, load the original content
				loadOriginalContent();
			}
		});
	}

	$("#search-field").on("input", function () {
		console.log(searchTimer);
		clearTimeout(searchTimer);
		searchTimer = setTimeout(performSearch, 500); // Delay before sending the AJAX request (in milliseconds)
	});

	function loadOriginalContent() {
		$.ajax({
			type: "POST",
			url: ajax_posts.ajaxurl,
			data: {
				action: "load_original_content",
			},
			success: function (response) {
				$(".more-archive-container").show();
				$("#archive--content").html(response);
			},
		});
	}

	// Handle the case when the search input is cleared
	$("#search-field").on("change", function () {
		if ($(this).val() === "") {
			loadOriginalContent();
		}
	});

	$("#search-field").keydown(function (event) {
		if (event.keyCode == 13) {
			console.log("Enter key pressed");
			event.preventDefault();
		}
	});

	if ($("#hawaiiwall").length > 0) {
		var wall = $("#hawaiiwall");
		var movableDivRight = $("#cloud-right");
		var movableDivLeft = $("#cloud-left");

		var scrollSpeed = 0.3;

		if (window.innerWidth < 1024) {
			scrollSpeed = 2 + 1;
		}
		var windowHeight = $(window).height();
		var windowWidth = $(window).width();

		var movableDivRightWidth = movableDivRight.width();
		var movableDivLeftWidth = movableDivLeft.width();

		var initialLeft = movableDivLeft.offset().left;
		var initialRight =
			windowWidth -
			(movableDivRight.offset().left + movableDivRight.outerWidth());

		/* if (window.innerWidth < 1024) {
		var initialLeft = "-1";
		var initialRight = "-100%";
	} */

		//console.log(initialLeft + " " + initialRight);
		/*console.log(movableDivRightWidth + " " + movableDivLeftWidth); */

		$(window).on("scroll", function () {
			var scrollTop = $(window).scrollTop();
			var wallTop = wall.offset().top;
			var wallBottom = wallTop + wall.height();

			var wallVisible =
				scrollTop + windowHeight > wallTop && scrollTop < wallBottom;

			var maxLeft = windowWidth - movableDivLeftWidth;
			var maxRight = windowWidth - movableDivRightWidth;

			var left = initialLeft + scrollTop * scrollSpeed;
			var right = initialRight + scrollTop * scrollSpeed;

			if (wallVisible) {
				if (window.innerWidth >= 1024) {
					movableDivRight.css("left", right + "px");
					movableDivLeft.css("right", left + "px");

					movableDivLeft.css("left", "unset");
					movableDivRight.css("right", "unset");
				} else {
					var left =
						(scrollTop / (wallBottom - windowHeight)) *
						maxLeft *
						scrollSpeed;
					var right =
						(scrollTop / (wallBottom - windowHeight)) *
						maxRight *
						scrollSpeed;

					//console.log(left + " " + right);
					/*
				movableDivRight.css("right", right + "px");
				movableDivLeft.css("left", left + "px"); */
				}
			}
		});
	}

	/* $("#enternow .btn").on("click", function () {
		$("#enternow").addClass("hidden");
		$("#sweepstakes").removeClass("hidden");
	}); */

	let sweepstakesPixelFired = false;

	/** #thankyou = new SheetDB entry; #entered = email/phone/rewards already in sheet. */
	function applyCheersSweepstakesHash() {
		const h = window.location.hash;
		const $form = $('form[name="twelve-form"]');

		if (h === "#sweepstakes") {
			$("#sweepstakes").removeClass("hidden");
			$("#entered").addClass("hidden");
			$("#thankyou").addClass("hidden");
			if ($form.length) {
				$form.css("display", "");
			}

			if (!sweepstakesPixelFired) {
				sweepstakesPixelFired = true;
				$("#footer").append(
					'<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=125603944727793&ev=PageView" /><img style="width:1px; height:1px;" src="https://servedby.flashtalking.com/spot/1/15214;141510;12636/?spotName=2024_SWA_Sweepstakes_SunsetontheBeach_Pageview&cachebuster=[' +
						Math.floor(Math.random() * 31231432431212) +
						']" />'
				);
			}
		} else if (h === "#thankyou") {
			$("#sweepstakes").addClass("hidden");
			$("#thankyou").removeClass("hidden");
			$("#entered").addClass("hidden");
			if ($form.length) {
				$form.css("display", "none");
			}
		} else if (h === "#entered") {
			if ($form.length) {
				$form.css("display", "none");
			}
			$("#entered").removeClass("hidden");
			$("#thankyou").addClass("hidden");
			const $entered = $("#entered");
			const $sweep = $("#sweepstakes");
			if (
				$sweep.length &&
				$entered.length &&
				!$sweep[0].contains($entered[0])
			) {
				$sweep.addClass("hidden");
			}
		}
	}

	applyCheersSweepstakesHash();
	$(window).on("hashchange", applyCheersSweepstakesHash);
});

/**
 * Form submission
 */

const scriptURLTwelve = "https://sheetdb.io/api/v1/3te9u888bmvwj";

function keepPageAtTopAfterHashChange() {
	const scrollToTop = () => {
		window.scrollTo({ top: 0, left: 0, behavior: "auto" });
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;
	};

	scrollToTop();
	requestAnimationFrame(scrollToTop);
	setTimeout(scrollToTop, 50);
	setTimeout(scrollToTop, 250);
}

function cheersSuccess(form, response) {
	console.log("Success!", response);
	form.style.display = "none";

	document.getElementById("sweepstakes").classList.add("hidden");
	document.getElementById("entered").classList.add("hidden");
	document.getElementById("thankyou").classList.remove("hidden");

	window.location.hash = "thankyou";
	keepPageAtTopAfterHashChange();
}

/** Sheet already has this entry — show #entered block and hash. */
function cheersDuplicateEntry(form) {
	form.style.display = "none";

	document.getElementById("sweepstakes").classList.add("hidden");
	document.getElementById("thankyou").classList.add("hidden");
	document.getElementById("entered").classList.remove("hidden");

	window.location.hash = "entered";
	keepPageAtTopAfterHashChange();
}

function cheersError(form, error) {
	console.error("Error!", error.message);
	document.getElementById("cheers-error").classList.remove("hidden");
}

if (document.forms["twelve-form"]) {
	const form = document.forms["twelve-form"];

	form.addEventListener("submit", (e) => {
		e.preventDefault();

		document.getElementById("cheers-error").classList.add("hidden");

		// Get form values
		const email = document.getElementById("form_field_email").value.trim();
		const phone = document.getElementById("form_field_phone").value.trim();
		const rewardsEl = document.getElementById("form_field_rewards");
		const rewards = rewardsEl ? rewardsEl.value.trim() : "";

		const duplicateChecks = [
			checkExistingEntry("email", email),
			checkExistingEntry("phone", phone),
		];
		if (rewards) {
			duplicateChecks.push(checkExistingEntry("rewards", rewards));
		}

		const rewardsValid = !rewardsEl || transformMbrCardNumber(rewards);

		// Check for duplicates before submitting
		Promise.all(duplicateChecks).then((results) => {
			const hasDuplicate = results.some((exists) => exists);

			if (hasDuplicate) {
				cheersDuplicateEntry(form);
			} else if (rewardsValid) {
				fetch(scriptURLTwelve, {
					method: "POST",
					mode: "cors",
					body: new FormData(form),
				})
					.then((response) => cheersSuccess(form, response))
					.catch((error) => cheersError(form, error));
			}

			// scroll to #header position
			$("html, body").animate(
				{
					scrollTop: $("#header").offset().top,
				},
				1000
			);

			// checkZip() &&
		});
	});
}
if (document.getElementById("form_field_rewards")) {
	var rewards = document.getElementById("form_field_rewards");

	rewards.addEventListener("input", function () {
		const mbrCardNumber = rewards.value;
		const isValid = transformMbrCardNumber(mbrCardNumber);

		if (isValid) {
			console.log("Valid card number");
			document
				.getElementById("form_field_rewards")
				.classList.remove("invalid");
			document
				.getElementById("form_field_rewards")
				.classList.add("valid");
		} else {
			console.log("Invalid card number");
			document
				.getElementById("form_field_rewards")
				.classList.remove("valid");

			document
				.getElementById("form_field_rewards")
				.classList.add("invalid");
		}
	});
}

function transformMbrCardNumber(mbrCardNumber) {
	mbrCardNumber = String(mbrCardNumber).trim();
	if (!mbrCardNumber) {
		return true;
	}

	if (mbrCardNumber.length < 14) {
		mbrCardNumber = mbrCardNumber.padStart(14, "0");
	}

	const first13Digits = Number(mbrCardNumber.substring(0, 13));
	const modulusResult = first13Digits % 7;
	const fourteenthCharacter = mbrCardNumber.charAt(13);

	if (modulusResult == fourteenthCharacter) {
		return true;
	} else {
		return false;
	}
}
/* */
document.querySelector("button.button").addEventListener("click", function () {
	let consent = document.getElementById("consent").checked;
	let fields = true;
	if (
		document.getElementById("form_field_name").value == "" &&
		document.getElementById("form_field_last").value == "" &&
		document.getElementById("form_field_email").value == "" &&
		document.getElementById("form_field_phone").value == "" &&
		document.getElementById("form_field_zip").value == ""
	) {
		fields = false;
	}

	if (fields) {
		if (!consent) {
			document
				.getElementById("cheers-error-checks")
				.classList.remove("hidden");
		}
	}
});

//document.getElementById("form_field_zip").addEventListener("input", checkZip);

/* const zipCodes = [
	"96783",
	"96718",
	"96728",
	"96841",
	"96782",
	"96762",
	"96729",
	"96805",
	"96860",
	"96757",
	"96781",
	"96809",
	"96812",
	"96774",
	"96804",
	"96808",
	"96776",
	"96749",
	"96817",
	"96785",
	"96778",
	"96771",
	"96780",
	"96773",
	"96857",
	"96824",
	"96720",
	"96717",
	"96764",
	"96819",
	"96742",
	"96748",
	"96721",
	"96760",
	"96710",
	"96727",
	"96777",
	"96801",
	"96734",
	"96737",
	"96772",
	"96840",
	"96759",
	"96827",
	"96795",
	"96859",
	"96719",
	"96739",
	"96731",
	"96704",
	"96740",
	"96837",
	"96743",
	"96850",
	"96725",
	"96822",
	"96830",
	"96806",
	"96745",
	"96786",
	"96815",
	"96750",
	"96797",
	"96755",
	"96839",
	"96738",
	"96726",
	"96802",
	"96826",
	"96766",
	"96796",
	"96791",
	"96853",
	"96769",
	"96706",
	"96751",
	"96716",
	"96789",
	"96730",
	"96828",
	"96722",
	"96754",
	"96843",
	"96747",
	"96846",
	"96765",
	"96756",
	"96847",
	"96703",
	"96746",
	"96810",
	"96715",
	"96816",
	"96705",
	"96836",
	"96820",
	"96714",
	"96803",
	"96838",
	"96848",
	"96712",
	"96752",
	"96863",
	"96741",
	"96811",
	"96709",
	"96767",
	"96784",
	"96788",
	"96814",
	"96861",
	"96732",
	"96792",
	"96733",
	"96813",
	"96761",
	"96770",
	"96768",
	"96844",
	"96807",
	"96744",
	"96779",
	"96713",
	"96793",
	"96707",
	"96708",
	"96825",
	"96854",
	"96818",
	"96898",
	"96858",
	"96763",
	"96849",
	"96790",
	"96753",
	"13",
	"96823",
	"96701",
	"96821",
]; */

/* function checkZip() {
	const inputField = document.getElementById("form_field_zip");

	const numericValue = inputField.value.replace(/\D/g, "");
	inputField.value = numericValue;
	console.log(numericValue);

	if (zipCodes.includes(numericValue)) {
		document.getElementById("form_field_zip").classList.remove("invalid");
		document.getElementById("form_field_zip").classList.add("valid");
		console.log("Valid zip code");

		return true;
	} else {
		document.getElementById("form_field_zip").classList.remove("valid");
		document.getElementById("form_field_zip").classList.add("invalid");
		console.log("Invalid zip code");

		return false;
	}
} */

function checkExistingEntry(type, value) {
	const scriptURL = "https://sheetdb.io/api/v1/3te9u888bmvwj";
	let searchParam = "";

	// Determine which field to search
	switch (type) {
		case "email":
			searchParam = `search?form_field_email=${encodeURIComponent(value)}`;
			break;
		case "rewards":
			searchParam = `search?form_field_rewards=${encodeURIComponent(value)}`;
			break;
		case "phone":
			searchParam = `search?form_field_phone=${encodeURIComponent(value)}`;
			break;
		default:
			return Promise.resolve(false);
	}

	return fetch(`${scriptURL}/${searchParam}`, {
		method: "GET",
		mode: "cors",
	})
		.then((response) => response.json())
		.then((data) => {
			console.log("Search result:", data);

			return data.length > 0;
		})
		.catch((error) => {
			console.error("Error checking existing entry:", error);
			// Return false on error
			return false;
		});
}
